import { ShieldCheck, Clock, Users, MessageSquare } from 'lucide-react';

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: <ShieldCheck size={48} className="text-primary-600" />,
      title: 'Jaringan yang Kuat',
      description:
        'Dengan jaringan luas di seluruh Indonesia, kami dapat menyediakan tenaga kerja berkualitas dari berbagai wilayah sesuai kebutuhan Anda.',
    },
    {
      icon: <Users size={48} className="text-primary-600" />,
      title: 'Tenaga Kerja Terampil',
      description:
        'Semua tenaga kerja kami melalui proses seleksi ketat dan pelatihan menyeluruh untuk memastikan kualitas dan profesionalisme.',
    },
    {
      icon: <Clock size={48} className="text-primary-600" />,
      title: 'Sistem Manajemen Efektif',
      description:
        'Kami menggunakan sistem manajemen modern untuk memastikan efisiensi operasional dan kualitas layanan terbaik.',
    },
    {
      icon: <MessageSquare size={48} className="text-primary-600" />,
      title: 'Komunikasi yang Baik',
      description:
        'Kami menjaga komunikasi terbuka dengan klien dan tenaga kerja untuk memastikan semua kebutuhan terpenuhi dengan baik.',
    },
  ];

  return (
    <section className="py-20 bg-navy-900 text-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Mengapa Memilih Kami
          </h2>
          <div className="w-20 h-1 bg-yellow-500 mx-auto"></div>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto mt-6">
            CV Samudera Alam Perkasa menawarkan keunggulan yang membedakan kami dari penyedia layanan tenaga kerja lainnya.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-lg bg-navy-800 hover:bg-navy-700 transition-all duration-300"
            >
              <div className="mb-4 inline-block">{reason.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-white">{reason.title}</h3>
              <p className="text-gray-300">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-navy-800 rounded-lg p-8 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            {[
              { count: '500+', label: 'Klien Puas' },
              { count: '1500+', label: 'Tenaga Kerja Tersalurkan' },
              { count: '10+', label: 'Tahun Pengalaman' },
              { count: '25+', label: 'Provinsi Terjangkau' },
            ].map((stat, index) => (
              <div key={index}>
                <div className="text-4xl font-bold text-yellow-500 mb-2">{stat.count}</div>
                <div className="text-gray-300">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;